import React, { Component } from "react";

import { isMobile } from "../../utils/deviceInfo";
import "./trivia-survey.css";
import {
  Button,
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  Popover,
  PopoverBody,
} from "reactstrap";
import { connect } from "react-redux";
import moment from "moment";
import { CSVLink } from "react-csv";
import axios from "../../axios";
import * as url from "../../utils/url";
import * as actionCreators from "../../modules/actions/index";
import Loading from "../../hoc/Loading/Loading";

import {
  LayoutHeadingShadow,
  LayoutRowShadow,
  LayoutData,
  LayoutHeadingShadowLeft,
  LayoutDataLines,
  LayoutRowLines,
} from "../../components/TableComponents/RowCardShadow/RowCardShadow";

import {
  getObjectForShareTrivvyResult,
  isTrivvyGeneratedFromCustomTemplates,
  SURVEY_LIST,
} from "./data";
import ReactTooltip from "react-tooltip";

import {
  BiDotsHorizontal,
  BiDownArrowAlt,
  BiEditAlt,
  BiUpArrowAlt,
  BiX,
} from "react-icons/bi";
import { BsDownload, BsThreeDots } from "react-icons/bs";

import { orderBy } from "lodash";
import EmptyTable from "../../components/EmptyTable/EmptyTable";
import { baseUrl, Spinner } from "../../utils/constants";
import MyTriviaDetails from "./Components/MyTriviaDetails";
import ShareEntity from "../../components/ShareEntity/ShareEntity";
import { GiOpenTreasureChest } from "react-icons/gi";
import TrivvyLinkedRewardsDetailsModal from "./Components/TrivvyLinkedRewardsDetailsModal";
import ViewSummaryCommon from "../../components/Trivvy/ViewSummarycomon";

class TriviaList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mySubmittedQuizes: [],
      hoveredSurvey: null,
      detailsModalOpen: false,
      detailsModalData: null,
      myAttempts: [],
      latestResult: null,
      rewardDescModalId: null,
      currentModalAverageDoc: null,
      optionsPopover: null,
      shareClickOpen: false,
      customModalText: null,
    };
  }

  openDetailsModal = (data) => {
    this.setState({
      detailsModalData: data,
      detailsModalOpen: true,
    });
  };

  closeDetailsModal = () => {
    this.setState({
      detailsModalData: null,
      detailsModalOpen: false,
    });
  };

  componentDidMount() {
    const { organizationId } = this.props.user.profile;

    if (isMobile) {
      this.props.updateNavBar({
        title: "Trivvy",
        hasBack: true,
        backButton: "<b>Back</b>",
        showNotification: true,
        className: null,
        isBreadCrumbs: false,
      });
    } else {
    }

    let that = this;

    //axios.get(url.findOrgById(organizationId._id)).then(({ data }) => {
    //  const payload = data.data;
    //  that.props.orgChangeSuccess(payload);
    //});

    this.retrieveMySubmittedQuizes();

    this.props.setCurrentTrivia(null);
  }

  componentWillReceiveProps(nextProps) {
    if (
      JSON.stringify(this.props.sortParams) !==
      JSON.stringify(nextProps.sortParams)
    ) {
      this.handleSortChange(
        nextProps.sortParams.sortBy,
        nextProps.sortParams.sortOrder
      );
    }
  }

  retrieveMySubmittedQuizes = () => {
    const { sortParams } = this.props;
    axios
      .post(url.getMyTakenQuizes, { fetchLatest: true })
      .then(({ data }) => {
        const params = new URLSearchParams(window.location.search);

        const docId = params.get("myDocId");

        if (docId) {
          const doc = data.data.find((x) => x.resultId == docId);

          if (doc) {
            this.setState({
              detailsModalOpen: true,
              detailsModalData: doc,
            });
          }
        }

        this.setState({ mySubmittedQuizes: data.data });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  retrieveMyAttemptsQuizes = (trivvyId) => {
    const { sortParams } = this.props;
    axios
      .post(url.getMyTakenQuizes, { fetchLatest: false, triviaId: trivvyId })
      .then(({ data }) => {
        this.setState({ myAttempts: data.data });
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .post(url.getMyAttemptsAvgDoc, { triviaId: trivvyId })
      .then(({ data }) => {
        this.setState({
          currentModalAverageDoc: data.data,
        });
      })
      .catch((err) => {
        this.setState({
          currentModalAverageDoc: null,
        });
      });
  };
  changeSortField = (key, order) => {
    this.props.updateSortParams({
      sortBy: key,
      sortOrder: order,
    });
  };

  handleSortChange = (key, order) => {
    let surveys = [...this.state.mySubmittedQuizes];

    surveys = surveys.map((x) => ({
      ...x,
      totalTime: x.totalTime >= 0 ? x.totalTime : 0,
    }));

    switch (key) {
      case "name":
        surveys = orderBy(surveys, (itm) => itm["triviaName"].toLowerCase(), [
          order,
        ]);
        break;

      case "responses":
        surveys = orderBy(surveys, (itm) => itm.quizResponsesCount, [order]);
        break;
      case "timeTaken":
        surveys = orderBy(surveys, (itm) => itm.totalTime, [order]);
        break;
      case "takenOn":
        surveys = orderBy(surveys, (itm) => itm.quizSubmittedAt, [order]);
        break;
      case "percentCorrect":
        surveys = orderBy(surveys, (itm) => itm.percentCorrect, [order]);
        break;
      case "attemptNumber":
        surveys = orderBy(surveys, (itm) => itm.attemptNumber, [order]);
        break;

      default:
        surveys = orderBy(surveys, (itm) => itm[key], [order]);
        break;
    }
    this.setState({ mySubmittedQuizes: surveys });
  };

  sortComponent = (key) => {
    const { sortParams } = this.props;
    // console.log('key --- ', key)
    if (JSON.stringify(sortParams.sortBy) === JSON.stringify(key)) {
      if (sortParams.sortOrder === "desc") {
        return (
          <BiDownArrowAlt
            size={"13px"}
            onClick={() => this.changeSortField(key, "asc")}
            className="cursor-pointer trivia-list-sort-arrow-pos"
          />
        );
      } else {
        return (
          <BiUpArrowAlt
            size={"13px"}
            onClick={() => this.changeSortField(key, "desc")}
            className="cursor-pointer trivia-list-sort-arrow-pos"
          />
        );
      }
    } else {
      return (
        <BiUpArrowAlt
          size={"13px"}
          onClick={() => this.changeSortField(key, "desc")}
          className="cursor-pointer trivia-list-sort-arrow-pos"
        />
      );
    }
  };

  getDataForExportResult = () => {
    const { mySubmittedQuizes } = this.state;

    if (mySubmittedQuizes && mySubmittedQuizes.length) {
      const myQuizArray = mySubmittedQuizes.map((x) => ({
        triviaName: x.triviaName || "NA",
        quizSumbittedAt: x.quizSubmittedAt
          ? moment(x.quizSubmittedAt).format("lll")
          : "NA",
        totalTime: `${x.totalTime || 0} sec`,
        totalQuestions: x.quizQuestions
          ? `${x.quizQuestions.length || 0}`
          : "0",
        totalCorrect: x.totalCorrect || 0,
        totalWrong: x.totalWrong || 0,
        percentCorrect: `${x.percentCorrect || 0}%`,
        createdBy: x.quizAdmin
          ? `${x.quizAdmin.firstName || ""} ${x.quizAdmin.lastName || ""}`
          : "",
      }));

      return myQuizArray;
    } else {
      return [];
    }
  };

  render() {
    const orgObject = this.props.user.profile.organizationId;
    const trivvy_plan_type = orgObject && orgObject.trivvyPlanType;
    const {
      mySubmittedQuizes,
      hoveredSurvey,
      detailsModalData,
      detailsModalOpen,
      latestResult,
      myAttempts,
      rewardDescModalId,
      currentModalAverageDoc,
      customModalText,
    } = this.state;
    const tableCols = {
      name: trivvy_plan_type == "001" ? 5 : 4,
      percentCorrect: 1,
      timeTaken: 1,
      takenOn: 2,
      attemptNumber: 1,
      action: 1,
      linkedRewards: 1,
      rating: 1,
    };

    const tableColsMobile = {
      rating: 1,
      percentCorrect: 2,
      timeTaken: 1,
      takenOn: trivvy_plan_type == "001" ? 3 : 2,
      action: 2,
      attemptNumber: 2,
      linkedRewards: 1,
    };

    const myTriviaHeaders = [
      {
        label: "Trivvy Name",
        key: "triviaName",
      },
      {
        label: "Submitted at",
        key: "quizSumbittedAt",
      },
      {
        label: "Total time Taken",
        key: "totalTime",
      },
      {
        label: "Total questions",
        key: "totalQuestions",
      },
      {
        label: "Total correct",
        key: "totalCorrect",
      },
      {
        label: "Total wrong",
        key: "totalWrong",
      },
      {
        label: "Correct %",
        key: "percentCorrect",
      },
      {
        label: "Created By",
        key: "createdBy",
      },
    ];

    const renderRetakeButton = (item) => {
      if (!latestResult && item.allowAttempts && item.allowAttempts > 0) {
        if (item.allowAttempts == 1) {
          if (item.attemptNumber >= item.numberOfAttemptsAlllowed) {
            return false;
          } else {
            return true;
          }
        } else if (item.allowAttempts == 2) {
          if (
            item.minimumPassingPercent &&
            item.percentCorrect >= item.minimumPassingPercent
          ) {
            return false;
          } else {
            return true;
          }
        }
      } else {
        return false;
      }
    };

    const isNonMcq = (responses) => {
      return (
        responses &&
        Array.isArray(responses) &&
        responses.filter((x) => x.question_type == "MCQ").length == 0
      );
    };

    const renderRowOptions = (item) => {
      const { optionsPopover } = this.state;

      return (
        <div>
          <span
            id={`surveyResultRow_${item.resultId}`}
            onClick={() => this.setState({ optionsPopover: item.resultId })}
            className="cursor-pointer"
          >
            <BsThreeDots />
          </span>
          <Popover
            isOpen={item.resultId == optionsPopover}
            target={`surveyResultRow_${item.resultId}`}
            toggle={() => {
              if (this.state.shareClickOpen) {
                this.setState({ shareClickOpen: false });
              } else {
                this.setState({ optionsPopover: null });
              }
            }}
            placement="bottom"
            hideArrow
            className="surveyListRow_Popover"
          >
            <PopoverBody className="">
              <div
                className="dropdown-item my-1 cursor-pointer"
                onClick={(e) => {
                  this.openDetailsModal(item);
                  this.setState({
                    optionsPopover: null,
                    shareClickOpen: false,
                  });
                }}
              >
                View
              </div>

              {item.librarySummaryText ? (
                <div
                  className="dropdown-item my-1 cursor-pointer"
                  onClick={(e) => {
                    
                    this.setState({
                      optionsPopover: null,
                      shareClickOpen: false,
                      customModalText:item.librarySummaryText
                    });
                  }}
                >
                  View summary
                </div>
              ) : (
                ""
              )}

              <div
                className="dropdown-item my-1 cursor-pointer"
                onClick={() => {
                  this.setState({
                    shareClickOpen: true,
                  });
                }}
              >
                <ShareEntity
                  customClass="p-0"
                  pooverUIMobileBorderClass={"border"}
                  comp={<span>Share</span>}
                  col
                  isTiny
                  customTinyPositions={["bottom", "left"]}
                  user={this.props.user}
                  entityType="TRIVVY"
                  display="POPPER"
                  item={{
                    ...getObjectForShareTrivvyResult(item),
                    triviaLink: `${baseUrl()}home/trivia/${
                      item.triviaOrgid
                    }/quiz/${item.triviaId}/start`,
                  }}
                />
              </div>
              {renderRetakeButton(item) && (
                <div
                  className="dropdown-item my-1 cursor-pointer"
                  onClick={() =>
                    window.open(
                      `${baseUrl()}home/trivia/${item.triviaOrgid}/quiz/${
                        item.triviaId
                      }/start`
                    )
                  }
                >
                  Retake
                </div>
              )}
            </PopoverBody>
          </Popover>
        </div>
      );
    };

    const tableUI = (quizes, showAttempts) => {
      const attemptText = showAttempts ? "Attempts" : "Attempt No";
      return (
        <div>
          {quizes.length == -1 ? (
            <div className="d-flex justify-content-center">
              <EmptyTable
                title={"No trivvys taken yet"}
                subtitle={"You havent taken any trivvys yet."}
              />
            </div>
          ) : (
            <div>
              {!isMobile ? (
                <div>
                  <div className="trivia_survey_list_table px-3">
                    <div className="my-4 trivia_survey_list_table_contents">
                      <LayoutRowShadow className="row-shadow-header-no-shadow">
                        {!isMobile && (
                          <LayoutHeadingShadowLeft
                            className={"text-left"}
                            colWidth={tableCols.name}
                          >
                            Name {this.sortComponent("name")}
                          </LayoutHeadingShadowLeft>
                        )}

                        <LayoutHeadingShadow
                          className={"justify-content-center"}
                          colWidth={tableCols.percentCorrect}
                        >
                          Correct % {this.sortComponent("percentCorrect")}
                        </LayoutHeadingShadow>
                        <LayoutHeadingShadow
                          className={"justify-content-center"}
                          colWidth={tableCols.timeTaken}
                        >
                          Time Taken {this.sortComponent("timeTaken")}
                        </LayoutHeadingShadow>
                        <LayoutHeadingShadow
                          className={"justify-content-center"}
                          colWidth={tableCols.rating}
                        >
                          Rating {this.sortComponent("rating")}
                        </LayoutHeadingShadow>
                        <LayoutHeadingShadow
                          className={"justify-content-center"}
                          colWidth={tableCols.takenOn}
                        >
                          Attempted on {this.sortComponent("takenOn")}
                        </LayoutHeadingShadow>
                        <LayoutHeadingShadow
                          className={"justify-content-center"}
                          colWidth={tableCols.attemptNumber}
                        >
                          {attemptText} {this.sortComponent("attemptNumber")}
                        </LayoutHeadingShadow>
                        {trivvy_plan_type !== "001" && (
                          <LayoutHeadingShadow
                            className={"justify-content-center"}
                            colWidth={tableCols.linkedRewards}
                          >
                            Rewards {this.sortComponent("linkedRewards")}
                          </LayoutHeadingShadow>
                        )}

                        <LayoutHeadingShadow
                          className={"justify-content-center"}
                          colWidth={tableCols.action}
                        ></LayoutHeadingShadow>
                      </LayoutRowShadow>
                      <div
                        className={`trivia_survey_list_table_contents_scroll ${
                          mySubmittedQuizes.length == 0
                            ? "trivvy-no-results"
                            : ""
                        }`}
                      >
                        {!isMobile && quizes.length > 0 ? (
                          quizes.map((item, idx) => {
                            let itm_color =
                              idx % 2 == 0 ? "#ff6233" : "#c6ffe7;";
                            return (
                              <LayoutRowShadow
                                key={idx}
                                onMouseEnter={() =>
                                  this.setState({ hoveredSurvey: item._id })
                                }
                                onMouseLeave={() =>
                                  this.setState({ hoveredSurvey: null })
                                }
                              >
                                <LayoutData
                                  colWidth={tableCols.name}
                                  className="cursor-pointer px-3"
                                >
                                  <div
                                    className="d-flex"
                                    onClick={(e) => {
                                      this.openDetailsModal(item);
                                    }}
                                  >
                                    <span
                                      className="trivia-list-item-color-chip"
                                      style={{ backgroundColor: itm_color }}
                                    >
                                      {" "}
                                    </span>

                                    <span
                                      // onClick={() => this.redirectToSurveyPage(item)}
                                      className="survey-item-title"
                                      style={{ display: "block" }}
                                    >
                                      {item.triviaName}
                                    </span>
                                  </div>
                                </LayoutData>
                                <LayoutData
                                  colWidth={tableCols.percentCorrect}
                                  className="text-center"
                                >
                                  {isTrivvyGeneratedFromCustomTemplates(item) ||
                                  item.isNonMcqTrivvy ||
                                  isNonMcq(item.quizResponses) ? (
                                    "N/A"
                                  ) : (
                                    <span> {item.percentCorrect || 0} %</span>
                                  )}
                                </LayoutData>
                                <LayoutData
                                  colWidth={tableCols.timeTaken}
                                  className="text-center"
                                >
                                  {item.totalTime || 0} s
                                </LayoutData>
                                <LayoutData
                                  colWidth={tableCols.rating}
                                  className="text-center"
                                >
                                  {item.rating > 0 ? item.rating : "No rating"}
                                </LayoutData>
                                <LayoutData
                                  colWidth={tableCols.takenOn}
                                  className="text-center font-13px"
                                >
                                  {moment(item.quizSubmittedAt).format(
                                    "h:mma on MMM D, YYYY"
                                  )}
                                </LayoutData>
                                <LayoutData
                                  colWidth={tableCols.attemptNumber}
                                  className="text-center"
                                >
                                  {showAttempts && item.attemptNumber > 1 ? (
                                    <b
                                      onClick={() => {
                                        this.setState({
                                          latestResult: item,
                                        });
                                        this.retrieveMyAttemptsQuizes(
                                          item.triviaId
                                        );
                                      }}
                                      className="text-info cursor-pointer"
                                    >
                                      {item.attemptNumber}
                                    </b>
                                  ) : (
                                    <span> {item.attemptNumber}</span>
                                  )}
                                </LayoutData>
                                {trivvy_plan_type !== "001" && (
                                  <LayoutData
                                    className="text-center"
                                    colWidth={tableCols.linkedRewards}
                                  >
                                    {item.linkedRewards &&
                                    item.linkedRewards.length ? (
                                      <GiOpenTreasureChest
                                        className="reward-icon-color reward-icon-size"
                                        onClick={() =>
                                          this.setState({
                                            rewardDescModalId: item.triviaId,
                                          })
                                        }
                                      />
                                    ) : (
                                      <GiOpenTreasureChest
                                        className="reward-icon-size"
                                        color="grey"
                                      />
                                    )}
                                  </LayoutData>
                                )}
                                <LayoutData
                                  colWidth={tableCols.action}
                                  className="text-center"
                                >
                                  {renderRowOptions(item)}
                                </LayoutData>{" "}
                              </LayoutRowShadow>
                            );
                          })
                        ) : (
                          <span>No trivvys taken yet</span>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="trivia_table_mobile mt-4">
                  <div
                    className={
                      latestResult && isMobile
                        ? "trivia_survey_list_table_contents_scroll_modal"
                        : "trivia_survey_list_table_contents_scroll"
                    }
                  >
                    <Row>
                      <Col xs={5} className="px-0">
                        <LayoutHeadingShadow
                          className={"justify-content-center"}
                          colWidth={12}
                        >
                          Name {this.sortComponent("name")}
                        </LayoutHeadingShadow>

                        {quizes.length == 0 ? (
                          <Row
                            className={
                              "planning-row-mobile-height layout-row-shadow mx-0"
                            }
                          >
                            <LayoutData colWidth={12}>
                              No trivvys taken yet
                            </LayoutData>
                          </Row>
                        ) : (
                          ""
                        )}

                        {quizes.map((item, idx) => {
                          return (
                            <Row
                              key={idx}
                              className={"planning-row-mobile-height px-0 mx-0"}
                            >
                              <LayoutDataLines colWidth={12} noFlex>
                                <div
                                  // onClick={() => this.redirectToSurveyPage(item)}
                                  className="cursor-pointer"
                                  onClick={(e) => {
                                    this.openDetailsModal(item);
                                  }}
                                >
                                  <div className="survey-item-title-itm">
                                    <span className="survey-item-title">
                                      {item.triviaName}
                                    </span>
                                  </div>
                                  {/*<div className="survey-createddate-text">
                                Created at{" "}
                                {moment(item.createdOn).format(
                                  "h:mma on MMM D, YYYY"
                                )}
                              </div>*/}
                                </div>
                                <ReactTooltip />
                              </LayoutDataLines>
                            </Row>
                          );
                        })}
                      </Col>

                      <Col xs={7} className="scrollable-action-table-row px-0">
                        <LayoutRowLines className="row-scroll-width-s">
                          <LayoutHeadingShadow
                            className={"justify-content-center"}
                            colWidth={tableColsMobile.percentCorrect}
                          >
                            Correct % {this.sortComponent("percentCorrect")}
                          </LayoutHeadingShadow>
                          <LayoutHeadingShadow
                            className={"justify-content-center"}
                            colWidth={tableColsMobile.timeTaken}
                          >
                            Time Taken {this.sortComponent("timeTaken")}
                          </LayoutHeadingShadow>
                          <LayoutHeadingShadow
                            className={"justify-content-center"}
                            colWidth={tableColsMobile.rating}
                          >
                            Rating {this.sortComponent("rating")}
                          </LayoutHeadingShadow>
                          <LayoutHeadingShadow
                            className={"justify-content-center"}
                            colWidth={tableColsMobile.takenOn}
                          >
                            Attempted on {this.sortComponent("takenOn")}
                          </LayoutHeadingShadow>
                          <LayoutHeadingShadow
                            className={"justify-content-center"}
                            colWidth={tableColsMobile.attemptNumber}
                          >
                            {attemptText} {this.sortComponent("attemptNumber")}
                          </LayoutHeadingShadow>

                          {trivvy_plan_type !== "001" && (
                            <LayoutHeadingShadow
                              className={"justify-content-center"}
                              colWidth={tableColsMobile.linkedRewards}
                            >
                              Rewards {this.sortComponent("linkedRewards")}
                            </LayoutHeadingShadow>
                          )}

                          <LayoutHeadingShadow
                            className={"justify-content-center"}
                            colWidth={tableColsMobile.action}
                          ></LayoutHeadingShadow>
                        </LayoutRowLines>

                        {quizes.map((item, idx) => {
                          return (
                            <LayoutRowLines
                              key={idx}
                              className={`pl-tasks-row ${
                                isMobile ? "row-scroll-width-s" : ""
                              }`}
                            >
                              <LayoutDataLines
                                colWidth={tableColsMobile.percentCorrect}
                                className="text-center text-success font-13px"
                              >
                                {isTrivvyGeneratedFromCustomTemplates(item) ||
                                item.isNonMcqTrivvy ||
                                isNonMcq(item.quizResponses) ? (
                                  "N/A"
                                ) : (
                                  <span> {item.percentCorrect || 0} %</span>
                                )}
                              </LayoutDataLines>
                              <LayoutDataLines
                                colWidth={tableColsMobile.timeTaken}
                                className="text-center text-danger font-13px"
                              >
                                {item.totalTime || 0} s
                              </LayoutDataLines>
                              <LayoutDataLines
                                colWidth={tableColsMobile.rating}
                                className="text-center font-13px"
                              >
                                {item.rating > 0 ? item.rating : "No rating"}
                              </LayoutDataLines>
                              <LayoutDataLines
                                colWidth={tableColsMobile.takenOn}
                                className="text-center text-info font-13px"
                              >
                                {moment(item.quizSubmittedAt).format(
                                  "h:mma on MMM D, YYYY"
                                )}
                              </LayoutDataLines>
                              <LayoutDataLines
                                colWidth={tableColsMobile.attemptNumber}
                                className="text-center text-info font-13px"
                              >
                                {showAttempts && item.attemptNumber > 1 ? (
                                  <b
                                    onClick={() => {
                                      this.setState({
                                        latestResult: item,
                                      });
                                      this.retrieveMyAttemptsQuizes(
                                        item.triviaId
                                      );
                                    }}
                                    className="text-info cursor-pointer"
                                  >
                                    {item.attemptNumber}
                                  </b>
                                ) : (
                                  <span> {item.attemptNumber}</span>
                                )}
                              </LayoutDataLines>
                              {trivvy_plan_type !== "001" && (
                                <LayoutDataLines
                                  className="text-center font-13px"
                                  colWidth={tableColsMobile.linkedRewards}
                                >
                                  {item.linkedRewards &&
                                  item.linkedRewards.length ? (
                                    <GiOpenTreasureChest className="reward-icon-color reward-icon-size" />
                                  ) : (
                                    <GiOpenTreasureChest
                                      className="reward-icon-size"
                                      color="grey"
                                    />
                                  )}
                                </LayoutDataLines>
                              )}
                              <LayoutDataLines
                                colWidth={tableColsMobile.action}
                                className="text-center"
                              >
                                <div style={{ display: "flex", gap: "10px" }}>
                                  <Button
                                    onClick={() => this.openDetailsModal(item)}
                                    size="sm"
                                    className="trivia-tbl-my-trivia-view ml-auto"
                                    // color="primary"
                                  >
                                    View
                                  </Button>
                                  <ShareEntity
                                    customClass="p-0"
                                    pooverUIMobileBorderClass={"border"}
                                    comp={
                                      <Button
                                        size="sm"
                                        className="trivia-tbl-my-trivia-view"
                                      >
                                        Share
                                      </Button>
                                    }
                                    col
                                    isTiny
                                    customTinyPositions={["bottom", "left"]}
                                    user={this.props.user}
                                    entityType="TRIVVY"
                                    display="POPPER"
                                    item={{
                                      ...getObjectForShareTrivvyResult(item),
                                      triviaLink: `${baseUrl()}home/trivia/${
                                        item.triviaOrgid
                                      }/quiz/${item.triviaId}/start`,
                                    }}
                                  />
                                  {renderRetakeButton(item) ? (
                                    <Button
                                      onClick={() =>
                                        window.open(
                                          `${baseUrl()}home/trivia/${
                                            item.triviaOrgid
                                          }/quiz/${item.triviaId}/start`
                                        )
                                      }
                                      size="sm"
                                      className="trivia-tbl-my-trivia-view"
                                      // color="primary"
                                    >
                                      Retake
                                    </Button>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              </LayoutDataLines>{" "}
                            </LayoutRowLines>
                          );
                        })}
                      </Col>
                    </Row>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      );
    };

    return (
      <div className="my-trivia-page">
        {detailsModalData && detailsModalOpen && (
          <MyTriviaDetails
            open={detailsModalOpen}
            onClose={this.closeDetailsModal}
            data={detailsModalData}
          />
        )}

        {customModalText && (
          <Modal isOpen={true}>
            <ModalHeader
              toggle={() => {
                this.setState({ customModalText: false });
              }}
              className="trivia_modal_header_bg"
            >
              Summary
            </ModalHeader>
            <ModalBody>{customModalText}</ModalBody>
          </Modal>
        )}

        {rewardDescModalId && rewardDescModalId.length > 0 ? (
          <TrivvyLinkedRewardsDetailsModal
            open={rewardDescModalId.length > 0}
            onClose={() =>
              this.setState({
                rewardDescModalId: null,
              })
            }
            trivvyId={rewardDescModalId}
          />
        ) : (
          ""
        )}

        {mySubmittedQuizes && mySubmittedQuizes.length ? (
          <CSVLink
            data={this.getDataForExportResult()}
            headers={myTriviaHeaders}
            filename={`My Trivias-${moment().format("MM/DD/YYYY")}.csv`}
            separator={","}
            target="_blank"
            className="ml-4 btn btn-sm trivia-action-button-main trivvy-export-table-btn"
            style={{
              height: "fit-content",
            }}
          >
            {"Export to CSV"} <BsDownload size={13} />
          </CSVLink>
        ) : (
          ""
        )}

        {tableUI(mySubmittedQuizes, true)}

        {latestResult && (
          <Modal
            className="resultsModal"
            isOpen={latestResult.resultId.length > 0}
          >
            <ModalHeader
              toggle={() =>
                this.setState({
                  latestResult: null,
                  myAttempts: [],
                  currentModalAverageDoc: null,
                })
              }
              className="trivia_modal_header_bg"
            >
              {latestResult ? latestResult.triviaName : "Trivvy"} Submission
              (all attempts)
            </ModalHeader>
            <ModalBody>
              {currentModalAverageDoc && currentModalAverageDoc._id ? (
                <div className="mt-4 p-3 display-trivia-res-stat">
                  <Row>
                    <Col md={3}>
                      <div className="title_text">Average score</div>
                      <div className="count_text_2">
                        {Math.round(currentModalAverageDoc.percentCorrect)}%
                      </div>
                    </Col>
                    <Col md={3}>
                      <div className="title_text">Average time</div>
                      <div className="count_text_2">
                        {Math.round(currentModalAverageDoc.totalOverallTime)}{" "}
                        <span className="title_text">(Seconds)</span>
                      </div>
                    </Col>
                    <Col md={3}>
                      <div className="title_text">Average rating</div>
                      <div className="count_text_2">
                        {parseFloat(currentModalAverageDoc.rating).toFixed(1)}
                      </div>
                    </Col>
                  </Row>
                </div>
              ) : null}

              <div className="mt-4">{tableUI(myAttempts, false)}</div>
            </ModalBody>
          </Modal>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    sortParams:
      state.sortFilterParams && state.sortFilterParams.myTrivia
        ? state.sortFilterParams.myTrivia.sort &&
          state.sortFilterParams.myTrivia.sort.hasOwnProperty("sortBy")
          ? state.sortFilterParams.myTrivia.sort
          : { sortBy: "", sortOrder: "" }
        : { sortBy: "", sortOrder: "" },
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateNavBar: (header) => dispatch(actionCreators.navBarUpdate(header)),
    orgChangeSuccess: (data) => dispatch(actionCreators.orgChangeSuccess(data)),
    setCurrentTrivia: (data) => dispatch(actionCreators.setCurrentTrivia(data)),
    updateSortParams: (data) =>
      dispatch(actionCreators.updateMyTriviaSort(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Loading(TriviaList, axios));
